import {ChatBubble} from './ChatBubble';
import {ChatBubbleNext, ChatBubbleNextProps} from './ChatBubbleNext';
import {TextBody} from './TextBody';
import {useNewUniversalHelpDesign} from '../../FeatureFlagsProvider';

export type Props = {
  body: string;
  background?: 'neutral100' | 'neutral600';
  children?: React.ReactNode;
  messageType: ChatBubbleNextProps['messageType'];
};

export const TextBubble = ({
  body,
  background = 'neutral100',
  messageType,
  children,
}: Props) => {
  const useNewDesign = useNewUniversalHelpDesign();

  if (useNewDesign) {
    return (
      <ChatBubbleNext messageType={messageType}>
        {body ? <TextBody body={body} /> : null}
        {children}
      </ChatBubbleNext>
    );
  }
  return (
    <ChatBubble background={background}>
      {body ? <TextBody body={body} background={background} /> : null}
      {children}
    </ChatBubble>
  );
};
